module.exports = __webpack_public_path__ + "static/media/gear.f40f96cc.svg";